import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavParams, Platform } from '@ionic/angular';
import { APIService } from 'src/providers/apiservices/apiservices';
import { GlobalService } from 'src/providers/apiservices/globalservices';
import { TokensProvider } from 'src/providers/tokens/tokens';
import { ValidacaoProvider } from 'src/providers/usuarios/validacao';
import { Md5 } from 'ts-md5/dist/md5';
import { v4 as uuidv4 } from 'uuid';


@Component({
  selector: 'app-tokens',
  templateUrl: './tokens.page.html',
  styleUrls: ['./tokens.page.scss'],
})
export class TokensPage implements OnInit {
  codigoSMS;
  codigoEmail;
  codigoVerificacaoOk;
  ddd;
  celular;
  celularFormat;
  emailAux;
  emailAuxFormat;
  isCadastro=false;
  enviarSmsEmail;
  nomeUsuario;
  diasLimite='0';
  usuario;

  dadosEnvio;
  cod1;
  cod2;
  cod3;
  cod4;
  cod5;
  cod6;

  isDisabledSMS=false;
  isDisabledEmail=true;;
  codigoSMSInformado="";
  codigoEmailInformado="";

  reenvio = true;
  timer = "00:00"

  reenvioEmail = false;
  timerEmail = "00:00";
  dispositivo;
  accessType: 'web' | 'android' | 'ios';
  ipAddress: string = '';

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    private tokensProvider: TokensProvider,
    private validacao: ValidacaoProvider,
    private globalService: GlobalService,
    private platform: Platform,
    
  ) 
  { 
    this.isCadastro = this.navParams.data.isCadastro;
    this.codigoSMS = this.navParams.data.sms;
    this.codigoEmail = this.navParams.data.email;
    this.ddd = this.navParams.data.ddd;
    this.celular = this.navParams.data.celular;
    this.celularFormat = this.isCadastro ? this.navParams.data.celular : this.navParams.data.celular.replace(this.navParams.data.celular.substr(0, 5), '*****');
    this.emailAux = this.navParams.data.usuarioEmail;
    // this.emailAuxFormat = this.navParams.data.usuarioEmail.replace(this.navParams.data.usuarioEmail.substr(0, 5), '*****');
    const email = this.navParams.data.usuarioEmail;

    if (email && email.includes('@')) {

      const [nome, dominioCompleto] = email.split('@');

      const dominioPartes = dominioCompleto.split('.');
      const dominio = dominioPartes[0];
      const extensao = dominioCompleto.substring(dominio.length);

      let nomeMascarado = '';
      let dominioMascarado = '';

      // 🔹 Caso nome pequeno (até 5 caracteres)
      if (nome.length <= 5) {
        const meioIndex = Math.floor(nome.length / 2);

        nomeMascarado =
          '*'.repeat(meioIndex) +
          nome[meioIndex] +
          '*'.repeat(nome.length - meioIndex - 1);
      }
      // 🔹 Caso nome maior
      else {
        nomeMascarado =
          '*'.repeat(5) +
          nome.substring(5, nome.length - 3) +
          '*'.repeat(3);
      }

      // 🔹 Mascara 3 caracteres do meio do domínio
      if (dominio.length > 3) {
        const meioDom = Math.floor(dominio.length / 2);

        dominioMascarado =
          dominio.substring(0, meioDom - 1) +
          '***' +
          dominio.substring(meioDom + 2);
      } else {
        dominioMascarado = dominio;
      }

      this.emailAuxFormat = `${nomeMascarado}@${dominioMascarado}${extensao}`;
    }

    this.dadosEnvio = this.navParams.data.dadosEnvio;
    this.enviarSmsEmail = this.navParams.data.isEnviarSmsEmail;
    this.nomeUsuario = this.navParams.data.nomeUsuario;
    this.usuario = this.navParams.data.usuario;
    

    APIService.numeroTokenInformado=null;
    
  }

  getOrCreateDeviceId(): string {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    let clipboard = event.clipboardData,
    text = clipboard.getData('Text');
    
    if(text && text.length >= 6)
    {
      this.cod1 = text.charAt(0);
      this.cod2 = text.charAt(1);
      this.cod3 = text.charAt(2);
      this.cod4 = text.charAt(3);
      this.cod5 = text.charAt(4);
      this.cod6 = text.charAt(5);
    }
  }

  onDigitInput(event){

    let element;
    if (event.code !== 'Backspace')
         element = event.srcElement.nextElementSibling;
 
     if (event.code === 'Backspace')
         element = event.srcElement.previousElementSibling;
 
    //this.codigoSMSInformado= "" + this.codigoSMSInformado + event.key;
    if(element == null)
         return;
     else
     {
         element.focus();
     }
 }
 getIpAddress(): Promise<void> {
    return fetch('https://api.ipify.org?format=json')
     .then(response => response.json())
     .then(data => {
       this.ipAddress = data.ip;
     })
     .catch(() => {
       this.ipAddress = '000.000.000.000';
     })
     .finally(() => {
        this.dispositivo = this.getOrCreateDeviceId();
        this.initWithDeviceId();
        if (this.platform.is('ios')) {
          this.accessType = "ios"
          // this.ipAddress = 
        }else if( this.platform.is('android')){
          this.accessType = "android"
        }else{
          this.accessType = "web"
        }
       
     });
  }
  ngOnInit() {
    // Ao abrir a tela, buscar ou gerar o deviceId antes de qualquer envio de token
    this.dispositivo = this.getOrCreateDeviceId();
    this.getIpAddress();
    //this.initWithDeviceId();
    // if (this.platform.is('ios')) {
    //   this.accessType = "ios"
    //   /**
    //    * Obtém o IP público do usuário e armazena em this.ipAddress
    //    */
    // }else if( this.platform.is('android')){
    //   this.accessType = "android"
    // }else{
    //   this.accessType = "web"
    // }
  }

  async initWithDeviceId() {
    // O deviceId já está disponível em this.dispositivo
    if (this.enviarSmsEmail) {
      if (this.enviarSmsEmail === "SMS") {
        this.reenviarCodigo();
      } else {
        this.reenviarCodigoEmail();
      }
    } else {
      this.enviarSmsEmail = "SMS"; // Nesse cenário o token foi gerado anteriormente, e só pode ser por SMS.
      this.startCountdown(60);
    }
  }

  async validaCodigoVerificao(strCodigoSMSInf, strCodigoEmailInf  ){
    
    strCodigoSMSInf = Md5.hashStr(strCodigoSMSInf) as string; 
    strCodigoEmailInf = Md5.hashStr(strCodigoEmailInf) as string;  

    if ((this.codigoSMS==strCodigoSMSInf) && (this.codigoEmail==strCodigoEmailInf )){
    //if (strCodigoEmailRec==strCodigoEmailInf ){
      this.codigoVerificacaoOk = true; 
      this.dismiss(true);
    
    }
    else{
      this.globalService.publishToast({Mensagem: "Os códigos de verificação informados são inválidos ou estão expirados. Dados não foram salvos.", Severidade:2, Posicao:"top"  });
    }

  }

  verificarSMS(){
      this.codigoSMSInformado=this.cod1+this.cod2+this.cod3+this.cod4+this.cod5+this.cod6;
      
      var strCodigoSMSInf = Md5.hashStr(this.codigoSMSInformado) as string; 
    
      if ((this.codigoSMS==strCodigoSMSInf)){
      //if (strCodigoEmailRec==strCodigoEmailInf ){
        this.isDisabledSMS = true; 
        APIService.numeroTokenInformado=this.codigoSMSInformado;
        //this.isDisabledEmail = false; 
        this.dismiss(true);
    
      }
      else{
        this.globalService.publishToast({Mensagem: "Código inválido.", Severidade:2, Posicao:"top"  });
    
      }
    
  }

  verificarEmail(){
    var strCodigoEmailInf = Md5.hashStr(this.codigoEmailInformado) as string;  

    if ((this.codigoEmail==strCodigoEmailInf )){
      APIService.numeroTokenInformado=this.codigoEmailInformado;
    //if (strCodigoEmailRec==strCodigoEmailInf ){
      this.dismiss(true);
    }
    else{
      this.globalService.publishToast({Mensagem: "O código de verificação do e-mail digitado é inválido. Favor verificar o valor digitado.", Severidade:2, Posicao:"top"  });
    }
  }
    onChangeDias(event: any) {
    if (event.detail.checked) {
      this.diasLimite = '30';
    } else {
      this.diasLimite = "0";
    }
  }

  async dismiss(sucesso) {
    if (sucesso === true) {
      try {
        await this.tokensProvider.setMfa(
          this.usuario,
          this.nomeUsuario,
          "",
          "",
          this.emailAux,
          this.diasLimite,
          this.dispositivo,
          this.accessType
        );

        this.modalCtrl.dismiss(sucesso, this.diasLimite);

      } catch (error: any) {
        this.globalService.publishToast({
          Mensagem: error.erro,
          Severidade: 2,
          Posicao: "top"
        });
      }
    } else {
      this.modalCtrl.dismiss(sucesso);
    }
  }

  startCountdown(seconds) {
    let counter = seconds;
    this.reenvio = true;

    const interval = setInterval(() => {
      //console.log(counter);
      counter--;
        
      if (counter < 0 ) {
        counter = 0;
        this.reenvio = false;
        clearInterval(interval);
      }

      this.timer = this.formatTime(counter);

    }, 1000);
  }

  startCountdownEmail(seconds) {
    let counter = seconds;
    this.reenvioEmail = true;

    const interval = setInterval(() => {
      counter--;
        
      if (counter < 0 ) {
        counter = 0;
        this.reenvioEmail = false;
        clearInterval(interval);
      }

      this.timerEmail = this.formatTime(counter);

    }, 1000);
  }

  formatTime(time) {   
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";
    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  }

  reenviarCodigo(){
    if (this.dadosEnvio){
      this.reenvioEmail = false;
      this.dadosEnvio.enviarTokenSms="S";
      this.sendCodigosViajantes();
    }
    else{
    this.sendCodigos("", this.ddd+this.celular,"");
    }

  }

  reenviarCodigoEmail(){
    if (this.dadosEnvio){
      this.reenvioEmail = true;
      this.dadosEnvio.enviarTokenSms="N";
      this.sendCodigosViajantes();

    }
    else{
      this.sendCodigosEmailDireto(this.usuario,this.emailAux, this.nomeUsuario, this.dispositivo);
    }
    
  }

  async sendCodigosViajantes() {
      let loading = await this.loadingController.create({
        message: 'Aguarde...'
      });
      loading.present();

      //chamar o serviço
      this.validacao.post(this.dadosEnvio).then(
      response => {
        var temp=[];
        var temp2;
        temp.push(response);

        if (temp[0].Item) {
          // temp2=JSON.parse(temp[0].Item);
          this.dadosEnvio=temp[0].Item;
          if (temp[0].Item.enviarTokenSms=="S"){
            this.codigoSMS = temp[0].Item.codigoToken;
          }
          else{
            this.codigoSMS = temp[0].Item.codigoToken;
            this.codigoEmail = temp[0].Item.codigoToken;;
          }
          
          loading.dismiss(); 

          // Reiniciar o cronometro
          this.startCountdown(60);
          this.reenvio = true;
        } else {
          loading.dismiss();
          this.globalService.publishToast({Mensagem: "Ocorreu um erro ao enviar os códigos verificação.", Severidade:2, Posicao:"top"  });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({Mensagem: error.erro, Severidade:2, Posicao:"top"  });
        loading.dismiss();
      });
    
  }

  async sendCodigos(strCpf, strCelular, strEmail) {
    if (strCelular || strEmail) {
      let loading = await this.loadingController.create({
        message: 'Aguarde...'
      });
      loading.present();

      //chamar o serviço
      // usuario, nome, cpf, numeroCelular, email
      this.tokensProvider.setTokens(
        this.dadosEnvio.usuario.Usuario
        , this.dadosEnvio.usuario.Nome 
        , this.dadosEnvio.usuario.Cpf
        , this.dadosEnvio.usuario.Celular
        , this.dadosEnvio.usuario.Email
        , this.dadosEnvio.usuario.diasLimite
        , this.dispositivo
        , this.accessType
      ).then(
      response => {
        var temp=[];
        var temp2;
        temp.push(response);

        if (temp[0].Item) {
          temp2=JSON.parse(temp[0].Item);
          this.codigoSMS = temp2.tokenSms;
          this.codigoEmail = temp2.tokenEmail;
          loading.dismiss(); 

          // Reiniciar o cronometro
          this.startCountdown(60);
          this.reenvio = true;
        } else {
          loading.dismiss();
          // TODO toast
         
          //this.events.publish('application:Toast', "Ocorreu um erro ao enviar os códigos verificação.", 2);
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({Mensagem: error.erro, Severidade:2, Posicao:"top"  });
        loading.dismiss();
      });
    } else {
      return false;
    }
  }

  async sendCodigosEmail(strCpf, strCelular, strEmail) {
    if (strCelular || strEmail){
      let loading = await this.loadingController.create({
        message: 'Aguarde...'
      });
      loading.present();

      //chamar o serviço
      this.tokensProvider.setTokens(
        this.dadosEnvio.usuario.Usuario
        , this.dadosEnvio.usuario.Nome 
        , this.dadosEnvio.usuario.Cpf
        , ""
        , this.dadosEnvio.usuario.Email
        , this.dadosEnvio.usuario.diasLimite
        , this.dispositivo
        , this.accessType
      ).then(
      response => {
        var temp=[];
        var temp2;
        temp.push(response);

        if (temp[0].Item) {
          temp2=JSON.parse(temp[0].Item);
          this.codigoSMS = temp2.tokenSms;
          this.codigoEmail = temp2.tokenEmail;
          loading.dismiss(); 

          // Reiniciar o cronometro
          this.startCountdownEmail(60);
          this.reenvioEmail = true;
        } else{
          loading.dismiss(); 
          this.globalService.publishToast({Mensagem: "Ocorreu um erro ao enviar os códigos verificação.", Severidade:2, Posicao:"top"  });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({Mensagem:  error.erro, Severidade:2, Posicao:"top"  });
        loading.dismiss();
      });
    } else {
      return false;
    }
  }

  async sendCodigosEmailDireto(usuario,strEmail, nome, dispositivo) {
    if (strEmail){
      let loading = await this.loadingController.create({
        message: 'Aguarde...'
      });
      loading.present();

      //chamar o serviço
      this.tokensProvider.setTokens(
        usuario
        , nome
        , ""
        , ""
        , strEmail
        , ""
        , dispositivo
        , this.accessType
      ).then(
      response => {
        var temp=[];
        var temp2;
        temp.push(response);

        if (temp[0].Item) {
          temp2=JSON.parse(temp[0].Item);
          this.codigoSMS = temp2.tokenSms;
          this.codigoEmail = temp2.tokenEmail;
          loading.dismiss(); 

          // Reiniciar o cronometro
          this.startCountdownEmail(60);
          this.reenvioEmail = true;
        } else{
          loading.dismiss(); 
          this.globalService.publishToast({Mensagem: "Ocorreu um erro ao enviar os códigos verificação.", Severidade:2, Posicao:"top"  });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({Mensagem:  error.erro, Severidade:2, Posicao:"top"  });
        loading.dismiss();
      });
    } else {
      return false;
    }
  }
}
